import Home from "../views/pages/home";
import InviteResponse from "../views/pages/invite-response";
import SuccessPage from "../views/pages/success-page";
import Page404 from "../views/pages/page-404";
import MainAppBar from "../views/header/main-app-bar";
import InviteResponseAppBar from "../views/header/invite-response-app-bar";
import PrivacyPolicy from "../views/pages/privacy-policy";
import TermsAndConditions from "../views/pages/terms-and-conditions";

export const routes = [
    {
        index: true,
        element: <MainAppBar><Home/></MainAppBar>
    },
    {
        path: '/invite/:id',
        element: <InviteResponseAppBar><InviteResponse/></InviteResponseAppBar>
    },
    {
        path: '/privacy',
        element: <MainAppBar><PrivacyPolicy/></MainAppBar>
    }, ,
    {
        path: '/terms',
        element: <MainAppBar><TermsAndConditions/></MainAppBar>
    }, ,
    {
        path: '/success',
        element: <MainAppBar><SuccessPage/></MainAppBar>
    },
    {
        path: '/not-found',
        element: <MainAppBar><Page404/></MainAppBar>
    },
    {
        path: '/*',
        element: <MainAppBar><Page404/></MainAppBar>
    },
]